/* eslint-disable sort-keys */
export default {
  light: {},
  dark: {},
};
